import React from 'react';
import { Link } from 'react-router-dom';
import { PopupboxManager } from 'react-popupbox';

import * as api from '../../api';

const MergePurchasePopup = ({ purchase, other, onSuccess, onError }) => {
  const onClick = async (event) => {
    event.preventDefault();

    const other_user =
      purchase.user_profile !== other.user_profile
        ? { other_user: other.user_profile }
        : {};
    const payload = {
      other: other.id,
      ...other_user,
    };

    try {
      const { data } = await api.mergePurchase(purchase.id, payload);
      onSuccess(data);
    } catch (err) {
      onError(err);
    } finally {
      PopupboxManager.close();
    }
  };

  return (
    <div className="merge-purchase-popup">
      <h3>Merge Purchases</h3>
      <div className="mar-t mar-b">
        You are merging purchase{' '}
        <Link target="_blank" to={`/purchases/${other.id}/view`}>
          #{other.id}
        </Link>{' '}
        into{' '}
        <Link target="_blank" to={`/purchases/${purchase.id}/view`}>
          #{purchase.id}
        </Link>
        .
      </div>
      <button className="btn btn-danger mar-t" type="button" onClick={onClick}>
        Merge and cancel purchase #{other.id}
      </button>
    </div>
  );
};

export default MergePurchasePopup;
